import { render } from "./ChampionSkills.vue?vue&type=template&id=0795d2c8&scoped=true"
import script from "./ChampionSkills.vue?vue&type=script&lang=ts"
export * from "./ChampionSkills.vue?vue&type=script&lang=ts"

import "./ChampionSkills.vue?vue&type=style&index=0&id=0795d2c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0795d2c8"

export default script